import { ROADWAY_FEATURE_VALUES } from '../constants/auto'
import { CROSSING_IMPROVEMENTS_VALUES } from '../constants/pedestrian'

export const counterMeasuresConfig = [
  {
    name: 'High-visibility crosswalk markings',
    alias: CROSSING_IMPROVEMENTS_VALUES[3],
    id: 'crossing_improvements',
    mode: 'pedestrian'
  },
  {
    name: 'Sidewalk',
    alias: 'Attached Sidewalks',
    id: 'pedestrian_facility_type',
    mode: 'pedestrian'
  },
  {
    name: 'Median with marked crossings',
    alias: CROSSING_IMPROVEMENTS_VALUES[1],
    id: 'crossing_improvements',
    mode: 'pedestrian'
  },
  {
    name: 'Pedestrian refuge island',
    alias: CROSSING_IMPROVEMENTS_VALUES[1],
    id: 'crossing_improvements',
    mode: 'pedestrian'
  },
  {
    name: 'Advance yield or stop markings and sign',
    alias: CROSSING_IMPROVEMENTS_VALUES[0],
    id: 'crossing_improvements',
    mode: 'pedestrian'
  },
  {
    name: 'Rectangular rapid-flashing beacon or pedestrian hybrid beacon',
    alias: CROSSING_IMPROVEMENTS_VALUES[4],
    id: 'crossing_improvements',
    mode: 'pedestrian'
  },
  {
    name: 'Leading pedestrian interval',
    alias: CROSSING_IMPROVEMENTS_VALUES[5],
    id: 'crossing_improvements',
    mode: 'pedestrian'
  },
  {
    name: 'Dedicated bicycle facility',
    alias: 'Dedicated bicycle facility',
    id: 'bike_facility_type',
    mode: 'bicycle'
  },
  {
    name: 'Single lane repurposing',
    alias: 'Lane Repurposing Planned',
    id: 'lane_repurposing_planned',
    mode: 'auto'
  },
  {
    name: 'Wider edge lines',
    alias: ROADWAY_FEATURE_VALUES[0],
    id: 'roadway_features',
    mode: 'auto'
  },
  {
    name: 'Longitudinal rumble strips and stripes',
    alias: ROADWAY_FEATURE_VALUES[1],
    id: 'roadway_features',
    mode: 'auto'
  },
  {
    name: 'SafetyEdge',
    alias: ROADWAY_FEATURE_VALUES[2],
    id: 'roadway_features',
    mode: 'auto'
  },
  {
    name: 'Backplates with reflective borders',
    alias: ROADWAY_FEATURE_VALUES[3],
    id: 'roadway_features',
    mode: 'auto'
  }
]
